<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener('DOMContentLoaded', function() {
    // Select the first sidebarBlock
    const brandsBlock = document.querySelector('.sidebarBlock.sidebar-categories');
    
    // Select the heading and content
    const brandsHeading = brandsBlock.querySelector('.sidebarBlock-heading');
    const brandsContent = brandsBlock.querySelector('.sidebarBlock-content');

    // Initially hide the content
    brandsContent.style.display = 'none';

    // Add click event listener to the heading
    brandsHeading.addEventListener('click', function() {
        // Toggle display property
        if (brandsContent.style.display === 'none' || brandsContent.style.display === '') {
            brandsContent.style.display = 'block'; // Show the brands section
            brandsHeading.classList.add('active'); // Add class when content is shown
        } else {
            brandsContent.style.display = 'none'; // Hide the brands section
            brandsHeading.classList.remove('active'); // Remove class when content is hidden
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Select the Price section heading
    const priceHeading = document.querySelector('.sibarbarBlock-filter-price .sidebarBlock-heading');
    
    // Select the corresponding content
    const priceContent = priceHeading.nextElementSibling; // Content immediately following the heading

    // Initially hide the content
    priceContent.style.display = 'none';

    // Add click event listener to the heading
    priceHeading.addEventListener('click', function() {
        // Toggle display property
        if (priceContent.style.display === 'none' || priceContent.style.display === '') {
            priceContent.style.display = 'block'; // Show the content
            priceHeading.classList.add('active'); // Add class when content is shown
        } else {
            priceContent.style.display = 'none'; // Hide the content
            priceHeading.classList.remove('active'); // Remove class when content is hidden
        }
    });
});

window.addEventListener("scroll", function() {
  const header = document.querySelector(".section-header-single-line");
  if (window.scrollY > 0) {
    header.classList.add("mysticky");
  } else {
    header.classList.remove("mysticky");
  }
});
